import { FC } from 'react';
import { ToggleProps } from './types';
import styles from './PunchupToggle.module.css';

const PunchupToggle: FC<ToggleProps> = ({
	disabled,
	handleChange,
	handleClick,
	id,
	isChecked,
	name,
	iconName: _iconName,
	...rest
}: ToggleProps) => (
	<label htmlFor={id ?? name} className={styles.label} data-disabled={disabled || undefined}>
		<input
			{...rest}
			aria-label={id ?? name}
			id={id ?? name}
			name={name}
			type="checkbox"
			className={styles.input}
			onChange={handleChange}
			disabled={disabled}
			onClick={handleClick}
			readOnly
			checked={isChecked}
		/>
		<span className={styles.track}>
			<span className={styles.knob} />
		</span>
	</label>
);

export { PunchupToggle };
